<template>
    <!-- goods list -->
    <div class="goods-list-box">
        <div class="category-list skeleton-rect">
            <div class="scroll">
                <div :class="['scroll-item',item.category_id == category_id ? 'active' : '']"
                     v-for="(item,index) in categoryList" :key="index" @click="tabCategory(item)">
                    <div class="name">
                        {{item.name}}
                    </div>
                </div>
            </div>
        </div>
        <div class="sub-category-list" style="border-bottom: 1px solid #e1e1e1;" v-if="!noresultCate">
            <div class="scroll clearfix">
                <div :class="['scroll-item',item.category_id == subCatid ? 'active' : '']"
                     v-for="(item,index) in subCategoryList" :key="index">
                    <div class="name" @click="tabSubCategory(item)">{{item.name}}</div>
                </div>
            </div>
        </div>
        <div class="goods-list" style="border-top:0px;">
            <nut-scroller
                :is-un-more="isUnMore"
                :type="'vertical'"
                @loadMore="loadMoreVert"
                :threshold=50
                pulldownTxt=""
                :stretch="20"
            >
                <div slot="list" class="list-item" v-for="(item,index) in goodsList" :key="index">
                    <router-link class="item" :to="{path: '/goods/show',query: {goods_id:item.goods_id}}">
                        <div class="image">
                            <img :src="item.goods_image" style="max-width: 80%;">
                        </div>
                        <div class="detail-box">
                            <div class="title skeleton-rect">{{item.goods_name}}</div>
                            <div class="volume">销量：{{item.goods_sales}}</div>
                            <div class="price-box skeleton-rect">
                                <div class="price">$ {{item.goods_sku.goods_price}}</div>
                                <div class="mark-price" v-if="item.goods_sku.line_price>0">$ {{item.goods_sku.line_price}}</div>
                            </div>
                        </div>
                    </router-link>
                    <div class="cart iconfont icon-gouwuche" @click="addCart(item.goods_id)"></div>
                </div>
                <!-- no-result -->
                <div class="noresult" v-if="noresult">
                    <div class="cot">
                        <div class="img">
                            <img src="../../assets/images/no_result.png">
                        </div>
                        <text class="text">抱歉，没有找到相关商品</text>
                    </div>
                </div>
                <!-- no-result end -->
            </nut-scroller>
        </div>
        <Tabber ref="updateNum"></Tabber>
    </div>
    <!-- goods list end -->
</template>
<script>
    import Tabber from '@/components/Tabber.vue'
    export default {
        name: 'GoodsList',
        components: {
            Tabber
        },
        data() { //默认数据
            return {
                noresult: false, //是否有数据
                isUnMore: false, //商品列表是否可以加载更多
                isLoading: false, //加载动画
                category_id: 10001, // 当前主分类 id
                noresultCate: false, // 是否有二级分类数据
                subCatid: 20,  // 当前子分类
                current_page: 1,
                last_page: 1,
                // 一级分类
                categoryList: [],
                //二级分类
                subCategoryList: [],
                goodsList: [],
            }
        },
        created() { //视图加载前执行
            let _this = this;
            this.loading = this.$toast.loading('Loading...', {
                coverColor: "rgba(0,0,0,0.5)",
            });
        },
        mounted() { //视图加载完成执行
            let _this = this;
            _this.category_id = _this.$route.query.category_id;
            _this.subCatid = _this.$route.query.subid;
            _this.getCategory(); // 获取左侧分类列表
            _this.getSubCategoryList(); // 获取二级分类列表
            _this.getGoodsList(); // 获取商品列表
        },
        methods: {

            // 获取分类左侧列表
            getCategory: function () {
                let _this = this;
                _this._get('category/index', {}, res => {
                    _this.setData({
                        categoryList: res.data.list
                    })
                })
            },

            /**
             * 获取二级分类列表
             */
            getSubCategoryList() {
                let _this = this;
                _this._get('category/subList', {category_id: _this.category_id}, res => {
                    if (res.data.subList) {
                        _this.subCategoryList = res.data.subList;
                        _this.noresultCate = false;
                    } else {
                        _this.subCategoryList = [];
                        _this.noresultCate = true;
                    }
                })
            },

            // 获取商品列表
            getGoodsList(page = 1) {
                let _this = this;
                _this._get('goods/lists', {
                    page: page,
                    category_id: _this.subCatid,
                    listRows: 40, // 分页
                }, res => {
                    if (!_this.subCatid) {
                        _this.noresult = true;
                        _this.goodsList = [];
                        this.$toast.fail('暂无商品数据');
                        _this.loading.hide();
                        return false;
                    }
                    if (res.data.list.data.length > 0) {
                        _this.noresult = false;
                        _this.goodsList = _this.goodsList.concat(res.data.list.data);
                        _this.current_page = res.data.list.current_page;
                        _this.last_page = res.data.list.last_page;
                        _this.isUnMore = false;
                    } else {
                        // 无结果数据
                        _this.noresult = true;
                        _this.goodsList = [];
                        _this.isUnMore = false;
                    }
                    _this.loading.hide();
                })
            },


            /**
             * 一级分类切换
             */
            tabCategory(item) {
                let _this = this,
                    id = item.category_id;
                this.loading = this.$toast.loading('Loading...', {
                    coverColor: "rgba(0,0,0,0.5)",
                });
                _this.category_id = id;
                _this.goodsList = [];
                _this.getChild(id);
            },

            // 查询子分类 id
            getChild(category_id) {
                let _this = this;
                _this._get('category/subList', {
                    'category_id': category_id
                }, res => {
                    if (res.data.subList) {
                        _this.subCatid = res.data.subList[0].category_id;
                        _this.subCategoryList = res.data.subList;
                        _this.noresultCate = false;
                    } else {
                        _this.subCatid = 0;
                        _this.subCategoryList = [];
                        _this.noresultCate = true;
                    }
                    _this.getGoodsList(); // 获取商品列表
                })
            },

            /**
             * 二级分类切换
             */
            tabSubCategory(item) {
                let _this = this;
                this.loading = this.$toast.loading('Loading...', {
                    coverColor: "rgba(0,0,0,0.5)",
                });
                _this.subCatid = item.category_id;
                _this.goodsList = [];
                _this.getGoodsList(); // 获取商品列表
            },
            /**
             *  添加购物车
             */
            addCart: function (id) {
                let _this = this;
                _this._post_form('cart/add', {
                    goods_id: id,
                    goods_num: 1,
                    goods_sku_id: 0,
                }, result => {
                    _this.$toast.success(result.msg);
                    _this.$nextTick(() => {
                        _this.$refs.updateNum.update(result.data.cart_total_num);
                    });
                })
            },
            /**
             *  触底加载
             */
            loadMoreVert() {
                if (this.current_page >= this.last_page) {
                    this.isUnMore = true;
                    return false;
                }
                this.isUnMore = false;
                this.loading = this.$toast.loading('Loading...', {
                    coverColor: "rgba(0,0,0,0.5)",
                });
                this.getGoodsList(this.current_page + 1);

            },

        },
        destroyed() {
            let _this = this;
            //切记页面销毁需要销毁
            _this.loading.hide();
        }
    }
</script>
<style lang="scss" scoped>
    @import "list.scss";
</style>
